import type { ReactNode } from "react";

export type BadgeTone = "default" | "mint" | "coral" | "violet" | "gold" | "dim";

/** A small status/label pill over the shared `.tag` primitive. */
export function Badge({ tone = "default", children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={tone === "default" ? "tag" : `tag tag-${tone}`}>{children}</span>;
}

/** Map a submission status to a tone + label. Plain words, not the raw enum. */
export function StatusBadge({ status }: { status: "valid" | "pending" | "rejected" | string }) {
  switch (status) {
    case "valid":
      return <Badge tone="mint">Counted</Badge>;
    case "pending":
      return <Badge tone="gold">Held for review</Badge>;
    case "rejected":
      return <Badge tone="coral">Rejected</Badge>;
    default:
      return <Badge tone="dim">{status}</Badge>;
  }
}
